// No hay endpoints de backend para el Wizard IG todavía (ver memoria del
// proyecto: la entrevista de Zeno y el build llegan después). Este service
// simula las respuestas para que el flujo completo sea demostrable ahora
// mismo; cuando el backend exista, solo hay que reemplazar el cuerpo de cada
// método por la llamada real — la forma de entrada/salida ya queda fija.

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const INTERVIEW_SCRIPT = [
  { key: 'tone', questionKey: 'chatQ1' },
  { key: 'salesFlow', questionKey: 'chatQ2' },
];

class WizardIgService {
  async saveBusinessInfo(business) {
    await delay(300);
    return { ok: true, business };
  }

  async savePaymentMethods(payments) {
    await delay(300);
    return { ok: true, payments };
  }

  async saveUseCase(orders) {
    await delay(300);
    return { ok: true, orders };
  }

  async savePolicies(policies) {
    await delay(300);
    return { ok: true, policies };
  }

  // Devuelve la siguiente pregunta de la entrevista, o null cuando terminó.
  // `answeredCount` es cuántas preguntas ya respondió el usuario.
  async getNextInterviewQuestion(answeredCount) {
    await delay(500);
    return INTERVIEW_SCRIPT[answeredCount] || null;
  }

  // Simula el build: recorre agent -> avatar -> workflow, reportando cada
  // transición vía onStageChange(stage, status).
  async startBuild(wizardState, { onStageChange } = {}) {
    const stages = ['agent', 'avatar', 'workflow'];
    for (const stage of stages) {
      onStageChange?.(stage, 'active');
      await delay(1400 + Math.random() * 900);
      onStageChange?.(stage, 'done');
    }
    return { ok: true };
  }
}

export default new WizardIgService();
